import { render, staticRenderFns } from "./GameWxBroad2.vue?vue&type=template&id=70411cb3&scoped=true&"
import script from "./GameWxBroad2.vue?vue&type=script&lang=js&"
export * from "./GameWxBroad2.vue?vue&type=script&lang=js&"
import style0 from "./GameWxBroad2.vue?vue&type=style&index=0&id=70411cb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70411cb3",
  null
  
)

export default component.exports